<template>
  <div>
    <!-- <span class="logo-mx3">MX3</span> <span class="logo-network">NETWORK</span> -->
    <img class="logo-site-img" :class="{ 'logo-footer-fixed': forceDark }" :src="logoSrc">
  </div>
</template>

<script>
export default {
  props: {
    // Rodapé sempre usa a logomarca do tema escuro (pedido explícito),
    // mesmo quando o site está no tema claro.
    forceDark: { type: Boolean, default: false },
  },
  data() {
    return {
      // Tema escuro mantém a logomarca original (new-logo.webp) sem
      // alteração. Tema claro usa a logomarca clara dedicada
      // (new-logo-light.webp), enviada especificamente para isso -
      // exceto quando forceDark=true (rodapé).
      //
      // Quando a página está sendo carregada dentro do iframe de
      // pré-visualização da tela "Personalizar" (Gerenciador de Produtos),
      // o tema exibido é forçado via query string (?mx3_preview_theme=dark
      // ou light) independente do que estiver salvo no localStorage deste
      // navegador - do contrário, ao pré-visualizar o Tema Escuro, a logo
      // podia continuar aparecendo na versão clara (ou vice-versa) se o
      // admin estivesse com o outro tema ativo na própria sessão. Mesma
      // lógica usada em App.vue para decidir o tema geral da pré-visualização.
      isDarkTheme: (() => {
        const previewTheme = new URLSearchParams(window.location.search).get("mx3_preview_theme");
        return previewTheme ? previewTheme !== "light" : localStorage.getItem("siteTheme") !== "light";
      })(),
    };
  },
  computed: {
    logoSrc() {
      if (this.forceDark) return "/img/new-logo.webp";
      return this.isDarkTheme ? "/img/new-logo.webp" : "/img/new-logo-light.webp";
    },
  },
  created() {
    this.$root.$on("mx3-theme-changed", this.onThemeChanged);
  },
  beforeDestroy() {
    this.$root.$off("mx3-theme-changed", this.onThemeChanged);
  },
  methods: {
    onThemeChanged(isDark) {
      this.isDarkTheme = isDark;
    },
  },
}
</script>

<style lang="scss">
.logo-site-img{
  height: 50px;
  margin-top: 0px;
}

/* Desktop: Aumentar tamanho da logo */
@media (min-width: 769px) {
  .logo-site-img {
    height: 85px !important;
  }
}

</style>